import { createFileRoute } from '@tanstack/react-router'

import { TenantAuditPage } from '@/pages/tenants/detail/TenantAuditPage'

export const Route = createFileRoute('/_authenticated/tenants/$id/audit')({
  component: TenantAuditPage,
})
